import { Skeleton } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { SearchCommunity } from '~/components/organisms/SearchCommunity';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { AppIcon } from '../atoms/AppIcon';
import { QuerySkeleton } from '../atoms/QuerySkeleton';

export type IAppCommunityPageProps = {
  appId: string;
};

export const AppCommunityPage: React.FC<IAppCommunityPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const appQuery = useAppQuery({ appId });

  const appName = appQuery.data?.name;

  return (
    <>
      <Helmet>
        <title>{t('AppCommunityPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={
          <Skeleton loaded={!appQuery.isLoading}>
            <AppIcon app={appQuery.data} />
          </Skeleton>
        }
        title={
          <QuerySkeleton query={appQuery} length={{ min: 8, max: 16 }}>
            {t('AppCommunityPage.title', { appName })}
          </QuerySkeleton>
        }
        subtitle={t('AppCommunityPage.subtitle')}
      />

      <SearchCommunity appId={appId} />
    </>
  );
};
